import './src/fragments'

import { maybeLoadLinkedInInsight } from './src/lib/linkedin-insight'

export const onClientEntry = () => {
  if (!window.__LINKEDIN_PARTNER_ID__) {
    return
  }

  const tryLoad = (event) => maybeLoadLinkedInInsight(event)

  window.addEventListener('cf_init', tryLoad)
  window.addEventListener('cf_consent', tryLoad)
  window.addEventListener('cf_consent_loaded', tryLoad)

  tryLoad()
}
